module.exports = __webpack_public_path__ + "static/media/statusBg.259935f8.svg";